 
/* Déclarer la dépendance Javascript avec Owl Carrousel - utile lors du webpack dans les projets templating*/
var owlCarousel = require("owl.carousel");

/* import des fichiers js nécessaires pour Carrousel et Card Carrousel*/
exports.carousel = require("./carousel");
exports.cardCarrousel = require("./card-carrousel");

